import { forwardRef } from "react";

import { NumberField as BaseNumberField } from "@base-ui/react/number-field";

import { cn } from "..";
import * as Control from "../Control/control.component";

export interface NumberFieldProps extends React.ComponentPropsWithRef<typeof BaseNumberField.Root> {
  error?: boolean;
  rounded?: boolean;
}

const NumberFieldRoot = forwardRef<HTMLDivElement, NumberFieldProps>((props, forwardedRef) => {
  const { className, error, rounded = false, disabled, ...rootProps } = props;

  return (
    <Control.Root asChild error={error} rounded={rounded} className={cn("p-0 overflow-hidden", className)}>
      <BaseNumberField.Root
        {...rootProps}
        ref={forwardedRef}
        data-error={error}
        data-rounded={rounded}
        disabled={disabled}
      />
    </Control.Root>
  );
});

NumberFieldRoot.displayName = "NumberField.Root";

export default NumberFieldRoot;
